import { useQueryClient } from 'vue-query'
import { useAuth } from '~/composables/auth/useAuth'

export const useContextRefresh = () => {
  const queryClient = useQueryClient()
  const { reactiveEventId } = useContext()
  const { me } = useAuth()

  // Watch for context changes and invalidate queries + refresh user participant data
  watch(reactiveEventId, async (newEventId, oldEventId) => {
    if (newEventId !== oldEventId) {
      console.log('Context changed, invalidating all queries. New eventId:', newEventId)
      await Promise.all([
        queryClient.invalidateQueries(),
        me(),
      ])
    }
  }, { immediate: false })

  // Manual refresh function
  const refreshAllQueries = async () => {
    await queryClient.invalidateQueries()
  }

  return {
    refreshAllQueries
  }
}
